module.exports = __webpack_public_path__ + "static/media/pallet.82f011c9.svg";